import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  StatusChip,
  LoadingSkeleton,
  NoDataSkeleton,
} from '../../../../common/components';

const formatDateTime = (value) => {
  if (!value) return '-';
  return new Date(value).toLocaleString('es-AR');
};

const NotificationRow = ({ notification }) => {
  const isRead = Boolean(notification.read_at);
  const contractsLabel =
    notification.contract_numbers?.length > 0 ? notification.contract_numbers.join(' · ') : '—';

  return (
    <TableRow hover>
      <RowTableCell>{contractsLabel}</RowTableCell>
      <RowTableCell>{notification.subscriber_name || 'Sin datos'}</RowTableCell>
      <RowTableCell>
        <Typography variant="subtitle2">{notification.title}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
          {notification.body}
        </Typography>
      </RowTableCell>
      <RowTableCell>{formatDateTime(notification.sent_at || notification.created_at)}</RowTableCell>
      <RowTableCell>{formatDateTime(notification.read_at)}</RowTableCell>
      <RowTableCell>
        <StatusChip
          status={isRead ? 'success' : 'warning'}
          label={isRead ? 'Leída' : 'No leída'}
          size="small"
        />
      </RowTableCell>
    </TableRow>
  );
};

const NotificationsTable = ({ notifications, isLoading, isFetching }) => {
  if (isLoading) {
    return (
      <Paper elevation={0} sx={{ p: 2, mb: 2 }}>
        <LoadingSkeleton />
      </Paper>
    );
  }

  return (
    <Paper elevation={0} sx={{ p: 0 }}>
      <GeneralTableBox>
        <Table>
          <TableHead>
            <TableRow>
              <HeadTableCell>Contrato(s)</HeadTableCell>
              <HeadTableCell>Suscriptor</HeadTableCell>
              <HeadTableCell>Mensaje</HeadTableCell>
              <HeadTableCell>Enviado</HeadTableCell>
              <HeadTableCell>Leído</HeadTableCell>
              <HeadTableCell>Estado</HeadTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {notifications.length === 0 && (
              <NoDataSkeleton
                colSpan={6}
                message="No hay notificaciones con los filtros actuales."
              />
            )}

            {notifications.map((notif) => (
              <NotificationRow key={notif.uuid} notification={notif} />
            ))}

            {isFetching && (
              <TableRow>
                <TableCell colSpan={6}>
                  <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
                    Actualizando datos...
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </GeneralTableBox>
    </Paper>
  );
};

export default NotificationsTable;
